import { IonModal } from '@ionic/react';
import styled from 'styled-components';

export const CoinsPaymentModalStyles = styled(IonModal)`
  --border-radius: 0;

  ion-content {
    --background: linear-gradient(
      0deg,
      #2b0e21 0%,
      #14111e 49.18%,
      #1e0f34 100%
    );

    &::part(scroll) {
      padding: 20px 16px;
    }

    .btn-buy-later {
      margin-top: 12px;
    }
  }
`;
